import base from './base2.repository';  
export default {
    get: params => base.get('pets', params),
    post: payload => base.post('pets', payload),
    species: {
        get: () => base.get('pets/species')
    },
    breeds: {
        get: () => base.get('pets/breeds')
    },
}